import React from "react";
import { getIconUrl } from "../../../../services/asset";
import styles from "./backButton.scss";

const BackButton = ({ onClick }) => (
  <button type="button" className={styles.button} onClick={onClick}>
    <img className={styles.icon} alt="" src={getIconUrl("chevron-left.svg")} />
  </button>
);

export default BackButton;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/StepFooter/BackButton/index.tsx